import LinkDiagramRoot, { Props } from './LinkDiagram'

export default function LinkDiagram(props: Props) {
  return <LinkDiagramRoot {...props} />
}
